export function notificationTimeAgo(value: unknown): string {
  const differenceMs = Date.now() - new Date(String(value)).getTime();
  const minutes = Math.round(differenceMs / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return new Date(String(value)).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function notificationDayBucket(value: unknown): string {
  const date = new Date(String(value));
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
  return date.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
}
